import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import './styles.scss';

export default class ContactFormSubsectionItem extends React.Component {
  static propTypes = {
    allowRemove: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    label: PropTypes.string.isRequired,
    primary: PropTypes.bool,
    onPrimaryChange: PropTypes.func,
    onRemove: PropTypes.func
  }

  static defaultProps = {
    allowRemove: true
  }

  handlePrimaryChange = (event) => {
    this.props.onPrimaryChange(event.target.checked);
  }

  render() {
    return (
      <div className="contact-form-subsection-item mt-3">
        <div className="contact-form-subsection-item-header px-3 py-0">
          <label>{this.props.label}</label>

          <div>
            {this.props.onPrimaryChange &&
              <label className="radio radio-inline">
                <input
                  checked={this.props.primary}
                  type="radio"
                  onChange={this.handlePrimaryChange}
                />
                Primary
              </label>
            }

            {!this.props.allowRemove ? null : (
              <FontAwesomeIcon
                className="ml-4 clickable"
                icon={faTrashAlt}
                name="remove"
                onClick={this.props.onRemove}
              />
            )}
          </div>
        </div>

        {this.props.children}
      </div>
    );
  }
}
